/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCashtag} from '../api'

export const useMutationSetCashtag = createReactQueryMutationHook('setCashtag', setCashtag)
